import React from 'react';
import { colorPalette } from '../../colorPalette';
import { Button } from '../Button';
import { CustomDrawer } from '../CustomDrawer';
import Save from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
export const Savebar = ({ isOpen, anchor = 'top', variant = 'persistent', mainLabel = 'Modification non enregistrées', cancelLabel, saveLabel = 'Enregistrer', onCancel = () => null, onSave = () => null, }) => {
    const contentStyle = {
        backgroundColor: colorPalette.gray900,
    };
    const listStyle = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: { xs: 'space-around', ta: 'space-between' },
        alignItems: 'center',
    };
    return (React.createElement(CustomDrawer, { anchorDirection: anchor, isOpen: isOpen, variant: variant, dialogContentStyle: contentStyle, listStyle: listStyle, hideBackdrop: true, onCloseCallBack: () => { } },
        React.createElement(Box, { sx: { display: { xs: 'none', ta: 'flex' }, color: colorPalette.white, fontSize: '1.8rem', fontWeight: 600 } }, mainLabel),
        React.createElement(Box, null,
            cancelLabel ? (React.createElement(Button, { sx: { mr: 2 }, size: "large", color: "secondary", variant: "contained", type: "button", onClick: onCancel }, cancelLabel)) : null,
            React.createElement(Button, { size: "medium", color: "tertiary", variant: "contained", type: "button", startIcon: React.createElement(Save, { fontSize: "small" }), onClick: onSave }, saveLabel))));
};
